
export enum UserGeographicalAssignmentTypes {
  CustomCountryList,
  Region,
  Global
}
